module.exports = __webpack_public_path__ + "media/images/iconNotification-c02b202f398359aa17ed093a18b6e8bc.png";